import { ASCENDING_KEY, SORT_BY_KEY } from '@/constants/state'
import type { BorrowMarketsSortState } from '@/types/borrowMarketsSortState'
import { type BorrowMarketsSortableColumn, isBorrowMarketsSortableColumn } from '@/types/borrowMarketsTableColumn'
import { useSearchState } from './useSearchState'

const DEFAULT_SORT_BY: BorrowMarketsSortableColumn = 'marketSize'
const DESCENDING_COLUMNS: BorrowMarketsSortableColumn[] = ['marketSize', 'availableToBorrow']

export function useBorrowMarketsSortState() {
  const { searchState, updateSearchState } = useSearchState({})

  const handleSetSortBy = (name: BorrowMarketsSortState['sortBy']): void => {
    const descendingByDefault = DESCENDING_COLUMNS.includes(name)
    const sortBy = searchState.get(SORT_BY_KEY)
    const previousAsc = searchState.get(ASCENDING_KEY) === 'true'
    const asc = sortBy === name ? !previousAsc : !descendingByDefault

    updateSearchState([SORT_BY_KEY, name], [ASCENDING_KEY, asc])
  }

  const asc = searchState.get(ASCENDING_KEY) === 'true'
  const sortByRaw = searchState.get(SORT_BY_KEY) ?? ''
  const sortBy =
    sortByRaw === 'liquidity'
      ? 'availableToBorrow'
      : isBorrowMarketsSortableColumn(sortByRaw)
        ? sortByRaw
        : DEFAULT_SORT_BY

  const sortState = {
    sortBy,
    asc,
  }

  return { handleSetSortBy, sortState }
}
